<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import axios from 'axios'

export default {
  page: {
    title: 'Starter',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Starter',
      items: [
        {
          text: 'Shreyu',
          href: '/',
        },
        {
          text: 'Pages',
          href: '/',
        },
        {
          text: 'Starter',
          active: true,
        },
      ],
      spreadsheets:{},
    }
  },
  created(){
    this.fetchData()
  },
  methods:{
    fetchData(){
      axiosGetPost('get','/contracts/')
        .then((response) => {
          let data = response
          this.spreadsheets = data.result
        })
    },
    checkTemplate(id){
      axiosGetPost('get',`/contracts/processing/${id}`)
      .then((response) => {
        let data = response
        if(data.success){
          alert('Template ID: ' + data.template_id)
        }else{
          alert('No template found.')
        }
      })
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Responsive tables</h4>
            <p class="sub-header">
              Create responsive tables by wrapping any
              <code>.table</code> in
              <code>.table-responsive</code>
              to make them scroll horizontally on small devices (under 768px).
            </p>

            <div class="table-responsive">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th>#id</th>
                    <th>Documento</th>
                    <th>Fecha</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(t, i) in spreadsheets"
                  :key="i">
                    <td>{{ t.id }}</td>
                    <td>{{ t.name }}</td>
                    <td>20/11/2020</td>
                    <td>
                      <b-button
                      size="sm"
                      variant="primary"
                      class="mr-1" 
                      :to="{ name: 'contract_preprocess', params: { id: t.id } }"
                      >
                        <i class="uil uil-robot"></i>
                      </b-button>
                      <b-button
                      size="sm"
                      variant="primary"
                      class="mr-1" 
                      :to="{ name: 'contract_preview', params: { id: t.id } }"
                      >
                        <i class="uil uil-eye"></i>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>